import { useState } from 'react';
import BackgroundOrbs from './components/layout/BackgroundOrbs';
import AppNav from './components/layout/AppNav';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Settings from './pages/Settings';

const VIEW_DASHBOARD = 'dashboard';
const VIEW_TRANSACTIONS = 'transactions';
const VIEW_SETTINGS = 'settings';

function App() {
  const [activeView, setActiveView] = useState(VIEW_DASHBOARD);

  return (
    <>
      <BackgroundOrbs />
      <AppNav activeView={activeView} onChange={setActiveView} />
      <main className="relative min-h-screen overflow-hidden">
        {activeView === VIEW_SETTINGS ? (
          <Settings />
        ) : activeView === VIEW_TRANSACTIONS ? (
          <Transactions />
        ) : (
          <Dashboard />
        )}
      </main>
    </>
  );
}

export default App;